import { CloseOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Card, ConfigProvider, Flex, Form, Input, Popconfirm, Select, Tour, Typography, Upload } from 'antd';
import { push } from 'connected-react-router';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout_CenterWithSidebar } from '../-components/layout/center-with-sidebar';
import { subjectOptions } from '../../../../Components/ApplicationPageComponents/ApplicationForm/SubjetOptions';
import { AutoHint } from '../../../../Components/UI/Hint/Hint';
import { getClientName, postNewApplication, saveId } from '../../../../Store/ApplicationsReducer/applicationsActions';
import { CustomAutoComplete } from '../../../../shared/components/auto-complete';
import styles from './index.module.css';

const fixedSubjectOptions = subjectOptions.map(option => ({
    value: option.value, label: option.value
}))
const FormItemLabel = ({ children, style, ...props }) => (
    <Typography.Text style={{ fontSize: 24, marginBottom: 16, color: '#4D525B', fontWeight: 700, ...style }} {...props}>{children}</Typography.Text>
)

const setConnectionInfo = (type, code) => {
    const connectionInfo = { type, code }
    localStorage.setItem('connectionInfo', JSON.stringify(connectionInfo));
}

const getConnectionInfo = () => {
    const connectionInfo = localStorage.getItem('connectionInfo');
    return connectionInfo ? JSON.parse(connectionInfo) : null;
}

const setDepartmentInfo = (department) => {
    localStorage.setItem('departmentInfo', department);
}

const getDepartmentInfo = () => {
    return localStorage.getItem('departmentInfo');
}

const connections = {
    teamviewer: {
        label: 'TeamViewer',
        placeholder_code: 'Введите код TeamViewer',
        placeholder_pass: 'Введите пароль TeamViewer',
    },
    anydesk: {
        label: 'AnyDesk',
        placeholder_code: 'Введите ID AnyDesk',
    }
}
const IsStringEmpty = (str) => typeof str === 'string' && (str || '')?.trim().length === 0;
const TrimmedStringValue = (value) => !IsStringEmpty(value) ? value?.trim() : '';

export const Application_DeviceId_NewTicket = (props) => {

    const dispatch = useDispatch();

    const match = props.match || {};
    const { deviceId } = match.params || {};
    const { clientName } = useSelector(state => state.applications)
    const [form] = Form.useForm();
    const connection_type = Form.useWatch('connection_type', form)
    const department = Form.useWatch('department', form)
    const values = Form.useWatch([], form);
    const [submittable, setSubmittable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openUpgradeTour, setOpenUpgradeTour] = useState(false);

    const refUpgradeBtn = useRef();

    const steps = [
        {
            title: 'Встречайте обновление в Asista!',
            description: 'Помимо привычной формы теперь есть чат с Искусственным Интеллектом. Он поможет заполнить заявку быстрее и без лишних шагов. Попробуйте новый формат 👇🏼',
            target: () => refUpgradeBtn.current,
            nextButtonProps: { children: 'Понятно' },
        },
    ];


    const show_field = {
        address: department === '2' || department === '12',
        printer_model: department === '12',
        connection_pass: connection_type === 'teamviewer'
    }

    useEffect(() => {
        dispatch(getClientName(deviceId));
        dispatch(saveId(deviceId));
        // Set department from localStorage if available
        const savedDepartment = getDepartmentInfo();
        if (savedDepartment) {
            form.setFieldsValue({
                department: savedDepartment
            });
        }
    }, [dispatch, deviceId, form]);

    useEffect(() => {
        const connectionInfo = getConnectionInfo();
        if (connectionInfo) {
            form.setFieldsValue({
                connection_type: connectionInfo.type,
                connection_code: connectionInfo.code,
            });
        }
    }, [form])

    useEffect(() => {
        form
            .validateFields({ validateOnly: true })
            .then(() => setSubmittable(true))
            .catch(() => setSubmittable(false));
    }, [form, values]);

    const handleSubmit = async (values) => {
        setIsLoading(true);
        const formData = new FormData();
        const files = Array.isArray(values.attachments) ? values.attachments.map((f) => f.originFileObj || f) : [];
        formData.append('companyName', 'itsupport');
        formData.append('id', deviceId);
        formData.append('problem', values.subject);
        formData.append('section', values.department);
        formData.append('message', [
            TrimmedStringValue(values.description),
            (TrimmedStringValue(values.address) ? `Адрес: ${TrimmedStringValue(values.address)}` : ''),
            (TrimmedStringValue(values.printer_model) ? `Модель принтера: ${TrimmedStringValue(values.printer_model)}` : ''),
            // add connection info if available
            (connection_type && values.connection_code) ? [
                `Данные для подключения (${connections[connection_type].label}): `,
                `- Код: ${values.connection_code}`,
                values.connection_pass ? `- Пароль: ${values.connection_pass}` : ''
            ].filter(Boolean).join('\n') : ''
        ].filter(Boolean).join('\n'));
        formData.append('tvpass', values.connection_code || '');
        if (Array.isArray(files)) {
            files.forEach((file) => {
                if (file) formData.append('files[]', file);
            });
        }
        setDepartmentInfo(values.department);
        setConnectionInfo(connection_type, values.connection_code || '');
        await dispatch(postNewApplication(formData, deviceId, false));
        setIsLoading(false);
    }

    const closeTour = () => {
        setOpenUpgradeTour(false);
        localStorage.setItem('hasSeenUpgradeTour', 'true');
    }

    useEffect(() => {
        if (refUpgradeBtn.current && !localStorage.getItem('hasSeenUpgradeTour')) {
            setTimeout(() => {
                setOpenUpgradeTour(true);
                localStorage.setItem('hasSeenUpgradeTour', 'true');
            }, 1500)
        }
    }, [refUpgradeBtn])

    return (
        <Layout_CenterWithSidebar {...props}>
            <Tour
                steps={steps}
                open={openUpgradeTour}
                onClose={closeTour}
            />

            <Flex vertical gap={24} style={{
                maxWidth: 1000,
                width: '100%',
                height: 'fit-content',
                margin: '0 auto',
                paddingBottom: '48px',
            }} >
                <Card className={styles.card} styles={{ body: { padding: 0 } }}  >
                    <Form
                        layout='vertical'
                        form={form}
                        onFinish={handleSubmit}
                        autoComplete="off"
                        requiredMark={false}
                        className={styles.form}
                    >
                        <Flex vertical gap={0}>
                            <Typography.Text style={{ fontSize: 26, marginBottom: 16, color: '#4D525B' }}>
                                <b>{clientName?.name || 'Anonymous'}</b>, здравствуйте! Опишите свою проблему.
                            </Typography.Text>
                            <FormItemLabel>Тема*</FormItemLabel>
                            <Form.Item
                                name="subject"
                                required
                                rules={[{ required: true, message: 'Пожалуйста, введите тему обращения' }]}>
                                <CustomAutoComplete
                                    count={{
                                        show: true,
                                        max: 256,
                                        strategy: (txt) => txt.length,
                                        exceedFormatter: (txt, { max }) => txt.slice(0, max),
                                    }}
                                    selectThemeToken={{
                                        showArrowPaddingInlineEnd: 80,
                                    }}
                                    optionRender={(option) => (
                                        <Typography.Text style={{ fontSize: 16, color: '#4D525B' }}>
                                            {option.label}
                                        </Typography.Text>
                                    )}
                                    options={fixedSubjectOptions}
                                    size='large'
                                    placeholder="Опишите кратко суть проблемы"
                                    filterOption={(inputValue, option) =>
                                        option?.value?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                />
                            </Form.Item>
                            <FormItemLabel>Отдел*</FormItemLabel>
                            <Form.Item
                                name="department"
                                required
                                rules={[{ required: true, message: 'Пожалуйста, выберите отдел' }]}>
                                <Select
                                    placeholder="В какой отдел отправить заявку?"
                                    size='large'
                                    optionRender={(option) => (
                                        <Typography.Text style={{ fontSize: 16, color: '#4D525B' }}>
                                            {option.label}
                                        </Typography.Text>
                                    )}
                                    labelRender={(({ label }) => (
                                        <Typography.Text style={{ fontSize: 16, color: '#4D525B' }}>
                                            {label}
                                        </Typography.Text>
                                    ))}
                                    allowClear
                                    options={[
                                        { label: 'Удаленная поддержка', value: '1' },
                                        { label: 'Выездные специалисты', value: '2' },
                                        { label: 'Сервисный центр', value: '3' },
                                        { label: 'Заправка и ремонт офисной техники', value: '12' },
                                        { label: 'Обслуживание серверов', value: '4' },
                                        { label: 'Продажи', value: '6' },
                                        { label: 'Бухгалтерия', value: '8' },
                                        { label: 'Аутстаффинг', value: '10' },
                                        { label: 'Я не знаю', value: '9' }
                                    ]}
                                />
                            </Form.Item>
                            <Flex vertical className={`ApplicationForm__input_hidden ${show_field.address ? "ApplicationForm__input_show" : ""}`}>
                                <FormItemLabel>Адрес</FormItemLabel>
                                <Form.Item name="address" rules={[{ required: show_field.address, message: 'Пожалуйста, введите адрес' }]}>
                                    <Input
                                        size='large'
                                        placeholder="Введите адрес для выездного специалиста"
                                    />
                                </Form.Item>
                            </Flex>
                            <Flex vertical className={`ApplicationForm__input_hidden ${show_field.printer_model ? "ApplicationForm__input_show" : ""}`}>
                                <FormItemLabel>Модель принтера</FormItemLabel>
                                <Form.Item name="printer_model" rules={[{ required: show_field.printer_model, message: 'Пожалуйста, введите модель принтера' }]}>
                                    <Input
                                        size='large'
                                        placeholder="Введите модель принтера"
                                    />
                                </Form.Item>
                            </Flex>
                            <FormItemLabel>Сообщение*</FormItemLabel>
                            <Form.Item
                                name="description"
                                rules={[{ required: true, message: 'Пожалуйста, опишите проблему' }]}>
                                <Input.TextArea
                                    rows={8}
                                    size='large'
                                    placeholder="Расскажите подробнее, например: утром вайфай еще работал, а после обеда выключается каждые пять минут отправляю письма, а они не доходят до получателей. Можно прикрепить к сообщению снимок экрана. Это поможет нам разобраться в проблеме." />
                            </Form.Item>
                            <Form.Item
                                size='large'
                                name="attachments"
                                valuePropName="fileList"
                                getValueFromEvent={e => Array.isArray(e) ? e : e && e.fileList}
                            >
                                <Upload
                                    name="files"
                                    beforeUpload={() => false}
                                    multiple
                                    style={{ flexDirection: 'row' }}
                                    itemRender={(oNode, file, fileList, actions) => (
                                        <Flex gap={8} align='center' justify='space-between' style={{ border: '1px solid #E8E8E8', padding: '4px 12px', borderRadius: 4, margin: '4px 0' }}>
                                            <Typography.Text style={{ color: '#4D525B', fontSize: 16, }}>
                                                {file.name}
                                            </Typography.Text>
                                            <Popconfirm
                                                title="Вы уверены, что хотите открепить этот файл?"
                                                placement='bottomRight'
                                                okText="Да"
                                                cancelText="Нет"
                                                onConfirm={() => actions.remove(file)}
                                            >
                                                <Button
                                                    color="primary" variant="text"
                                                    style={{ fontSize: 16, }} size='small'
                                                    icon={<CloseOutlined />}
                                                />
                                            </Popconfirm>
                                        </Flex>
                                    )}
                                >
                                    <Flex gap={8} align='center' style={{ cursor: 'pointer' }}>
                                        <PaperClipOutlined style={{ transform: 'rotate(90deg) rotateX(180deg)', fontSize: 32, height: 32, width: 32, color: '#4D525B' }} />
                                        <Typography.Text style={{ color: '#4D525B', fontSize: 16, fontWeight: 700, }}>
                                            Добавить файлы
                                        </Typography.Text>
                                        <AutoHint hint="Прикрепите необходимые по вашему мнению файлы" />
                                    </Flex>
                                </Upload>
                            </Form.Item>
                            <Flex gap={20} wrap className={styles.bottom_container} justify='space-between' align='end'>
                                <Flex vertical>
                                    <FormItemLabel>Данные для подключения</FormItemLabel>
                                    <Form.Item style={{ margin: 0 }}>
                                        <Flex gap={12} wrap justify='center'>
                                            <Form.Item name="connection_type" noStyle>
                                                <Select
                                                    placeholder="Тип"
                                                    style={{ width: 180 }}
                                                    allowClear
                                                    size='large'
                                                    optionRender={(option) => (
                                                        <Typography.Text style={{ fontSize: 16, color: '#4D525B' }}>
                                                            {option.label}
                                                        </Typography.Text>
                                                    )}
                                                    options={
                                                        Object.entries(connections).map(([key, { label }]) => ({
                                                            label,
                                                            value: key
                                                        }))
                                                    }
                                                />
                                            </Form.Item>
                                            <Form.Item name="connection_code" noStyle>
                                                <Input
                                                    size='large'
                                                    style={{ width: 180 }}
                                                    placeholder={connections[connection_type]?.placeholder_code || 'Введите данные для подключения'}
                                                    autoComplete='off'
                                                    disabled={!connection_type}
                                                />
                                            </Form.Item>
                                            <Flex vertical className={`ApplicationForm__input_hidden ${show_field.connection_pass ? "ApplicationForm__input_show" : ""}`}>
                                                <Form.Item name="connection_pass" noStyle>
                                                    <Input.Password
                                                        size='large'
                                                        style={{ width: 180 }}
                                                        placeholder={connections[connection_type]?.placeholder_pass || 'Введите данные для подключения'}
                                                        autoComplete='off'
                                                        disabled={!connection_type}
                                                    />
                                                </Form.Item>
                                            </Flex>
                                        </Flex>
                                    </Form.Item>
                                </Flex>
                                <Flex justify='end'>
                                    <ConfigProvider theme={{ components: { Button: { colorPrimary: '#4fc6e0', algorithm: true } } }}>
                                        <Form.Item shouldUpdate noStyle>
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                size='large'
                                                style={{ width: 200 }}
                                                loading={isLoading}
                                                disabled={!submittable || isLoading}
                                            >
                                                Отправить заявку
                                            </Button>
                                        </Form.Item>
                                    </ConfigProvider>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Form>
                </Card>
                <Flex justify='center'>
                    <Button
                        ref={refUpgradeBtn}
                        type="primary"
                        onClick={() => {
                            dispatch(push(`/application/${deviceId}/new/chat`));
                            closeTour();
                        }}
                    >Перейти в новую версию</Button>
                </Flex>
            </Flex>
        </Layout_CenterWithSidebar>
    );
};
